import { render, staticRenderFns } from "./OperadoresSPC.vue?vue&type=template&id=74b85637&scoped=true&"
import script from "./OperadoresSPC.vue?vue&type=script&lang=js&"
export * from "./OperadoresSPC.vue?vue&type=script&lang=js&"
import style0 from "./OperadoresSPC.vue?vue&type=style&index=0&id=74b85637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b85637",
  null
  
)

export default component.exports